module.exports = __webpack_public_path__ + "static/img/logo_jt_6.12133f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo_jt_6.png
// module id = 4i5B
// module chunks = 0